import { MultiselectFormField, TextFormField } from "@/components/ui";
import { CheckboxFormField } from "@/components/ui/FormFields/CheckboxFormField/CheckboxFormField";
import {
  CONTACT_ORGANIZATION_MEDICAL_PROVIDER_SPECIALIZATIONS,
  CONTACT_ORGANIZATION_SUBTYPES,
} from "@/lib/data/static/contactStatics";
import { useFormContext } from "react-hook-form";

export const ContactOrganizationFormSection = () => {
  const form = useFormContext();
  return (
    <>
      <MultiselectFormField
        label="Contact sub-types"
        register={form.register("organizationSubTypes")}
        options={CONTACT_ORGANIZATION_SUBTYPES.map((subtype) => ({
          label: subtype,
          value: subtype,
        }))}
        maxCount={1}
        dataTestId="contact-organization-subtypes"
      />
      <TextFormField
        register={form.register("organizationName")}
        label="Organization name*"
        dataTestId="contact-organization-name"
      />
      <TextFormField
        register={form.register("organizationFoundingYear")}
        label="Founding year"
        type="number"
      />
      <TextFormField
        register={form.register("organizationTaxId")}
        label="Tax ID"
      />
      {form.watch("organizationSubTypes")?.includes("Medical Provider") && (
        <>
          <MultiselectFormField
            options={CONTACT_ORGANIZATION_MEDICAL_PROVIDER_SPECIALIZATIONS.map(
              (specialization) => ({
                label: specialization,
                value: specialization,
              }),
            )}
            label="Specializations"
            register={form.register(
              "organizationMedicalProviderSpecialization",
            )}
            maxCount={1}
          />
          <CheckboxFormField
            label="Accepts liens"
            register={form.register("organizationMedicalProviderAcceptsLiens")}
          />
        </>
      )}
    </>
  );
};
